import React, { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Styles.css";
import JobModal from "../Job Modal/JobModals";
import jobData from "../../data/Jobs/JobsData";
import webdev from "../../assets/Images/webdev.png";
import compsyst from "../../assets/Images/compsyst.png";
import sofdev from "../../assets/Images/softdev.png";
import infsec from "../../assets/Images/infsec.png";
import systsoft from "../../assets/Images/syssoft.png";
import compsup from "../../assets/Images/compsup.png";
import dba from "../../assets/Images/dba.png";
import comptinf from "../../assets/Images/comptinf.png";
import compnet from "../../assets/Images/compnet.png";
import netcomp from "../../assets/Images/netcomp.png";

const JobSection = () => {
  AOS.init({ duration: 1000 });

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    description: "",
    tasks: [],
    skills: "",
  });

  const handleShowModal = (title, description, tasks, skills) => {
    setModalContent({
      title,
      description,
      tasks,
      skills,
    });
    setShowModal(true);
  };

  return (
    <div className="job-section">
      <p className="title-job-section">
        Computer and Information <br />
        Technology Occupations
      </p>

      <div className="job-category1" data-aos="fade-up">
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={webdev} alt={webdev} />
          </div>
          <p className="job-title">
            Web Developer <br />& Digital Designer
          </p>
          <p className="job-description">
          Web developers create and maintain websites. Digital designers 
            develop, create, and test website or interface layout,...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[0].title,
                jobData[0].description,
                jobData[0].tasks,
                jobData[0].skills
              )
            }
          >
            More
          </button>
        </div>

        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={compsyst} alt={compsyst} />
          </div>
          <p className="job-title">
            Computer Systems <br />
            Analysts
          </p>
          <p className="job-description">
          study an organization’s current computer systems 
          and procedures and design improvements to them...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[1].title,
                jobData[1].description,
                jobData[1].tasks,
                jobData[1].skills
              )
            }
          >
            More
          </button>
        </div>
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={sofdev} alt={sofdev} />
          </div>
          <p className="job-title">
            Software Developer, Quality Assurance Analyst & Testers
          </p>
          <p className="job-description">
          Software developers create the computer applications that allow users
           to do specific tasks  ...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[2].title,
                jobData[2].description,
                jobData[2].tasks,
                jobData[2].skills
              )
            }
          >
            More
          </button>
        </div>
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={infsec} alt={infsec} />
          </div>
          <p className="job-title">
            Information Security <br />
            Analysts
          </p>
          <p className="job-description">
          Information security analysts plan and carry out security 
          measures to protect an organization’s ...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[3].title,
                jobData[3].description,
                jobData[3].tasks,
                jobData[3].skills
              )
            }
          >
            More
          </button>
        </div>
      </div>

      <div className="job-category2" data-aos="fade-up">
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={systsoft} alt={systsoft} />
          </div>
          <p className="job-title">
            Computer <br />
            Programmers
          </p>
          <p className="job-description">
          Computer programmers write, modify, and test code and scripts 
          that allow computer software and applications...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[4].title,
                jobData[4].description,
                jobData[4].tasks,
                jobData[4].skills
              )
            }
          >
            More
          </button>
        </div>
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={compsup} alt={compsup} />
          </div>
          <p className="job-title">
            Computer Support <br />
            Specialists
          </p>
          <p className="job-description">
          Computer support specialists maintain computer 
          networks and provide technical ...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[5].title,
                jobData[5].description,
                jobData[5].tasks,
                jobData[5].skills
              )
            }
          >
            More
          </button>
        </div>
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={dba} alt={dba} />
          </div>
          <p className="job-title">
            Database Administrators <br /> and Architects
          </p>
          <p className="job-description">
          Database administrators and architects create 
          or organize systems to store and...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[6].title,
                jobData[6].description,
                jobData[6].tasks,
                jobData[6].skills
              )
            }
          >
            More
          </button>
        </div>
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={comptinf} alt={comptinf} />
          </div>
          <p className="job-title">
            Computer & Information <br />
            Research Scientists
          </p>
          <p className="job-description">
          Computer and information research scientists
           design innovative uses for new ...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[7].title,
                jobData[7].description,
                jobData[7].tasks,
                jobData[7].skills
              )
            }
          >
            More
          </button>
        </div>
      </div>

      <div className="job-category3" data-aos="fade-up">
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={compnet} alt={compnet} />
          </div>
          <p className="job-title">
            Computer Network <br />
            Architects
          </p>
          <p className="job-description">
          Computer network architects design and build data communication networks, 
          including local area networks (LANs), ...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[8].title,
                jobData[8].description,
                jobData[8].tasks,
                jobData[8].skills
              )
            }
          >
            More
          </button>
        </div>
        <div className="job-category-card">
          <div className="job-icon">
            <img className="job-icon" src={netcomp} alt={netcomp} />
          </div>
          <p className="job-title">
            Network & Computer <br />
            Systems Administrators
          </p>
          <p className="job-description">
          Network and computer systems administrators install, configure, 
          and maintain organizations’ computer networks and system ...
          </p>
          <button
            className="btn-more"
            onClick={() =>
              handleShowModal(
                jobData[9].title,
                jobData[9].description,
                jobData[9].tasks,
                jobData[9].skills
              )
            }
          >
            More
          </button>
        </div>
      </div>

      <JobModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalContent.title}
        description={modalContent.description}
        tasks={modalContent.tasks}
        skills={modalContent.skills}
      />
    </div>
  );
};

export default JobSection;
